// translations/pages/team/sv.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageSV = {
  hero: {
    title: 'Team',
    intro: 'Adrian Eisenmeier och Nikolai Genov har grundat pAIoneer Labs GmbH och leder bolaget som verkställande direktörer.',
    members: 'Adrian Eisenmeier är diplomfysiker och utvecklar system där AI, mjukvaruarkitektur, dataskydd och säkerhet möts. Nikolai Genov är disputerad bioinformatiker och teknisk ledare för AI-stödd mjukvaruutveckling och analys i reglerade miljöer inom hälso- och sjukvård, life science och finans. Alina Tselinina är mjukvaruutvecklare och data engineer med en masterexamen i finans- och försäkringsmatematik och utvecklar applikationer, REST-API:er och datapipelines i Python och R.'
  },
  card: {
    cta: 'Visa profil'
  },
  profile: {
    overview: 'Team',
    membersLabel: 'Teammedlemmar'
  }
};
